<ng-template #templateModal>
    <div class="modal-body d-flex align-items-center contact-modal rounded-4">
        <div class="container">
            <div class="row d-flex justify-content-center align-items-center mt-4">
                <div class="col text-center">
                    <label class="mb-0 h1 fw-bolder text-primary" style="margin-left: 10%;">Sala de Soporte ALDDA</label>
                </div>
                <div class="col-1 ms-auto text-center">
                    <span class="rounded-circle bg-warning p-2 cursor-pointer" (click)="closeModal()">
                        <i class="fas fa-times text-white mx-1"></i>
                    </span>  
                </div>
            </div>
            <div class="row my-5 px-4">
                <div class="col-4">
                    <div class="card shadow rounded-4 border-success h-100">
                        <img src="assets/images/zoom-contact-modal.png" class="rounded-top-4" alt="ALDDA - Zoom">
                        <div class="card-body d-flex flex-column">
                            <h4 class="card-title text-uppercase text-primary fw-bolder mb-1">Sala de <br>soporte Zoom:</h4>
                            <p class="card-text text-muted">Comparte tu pantalla vía <br><b>ZOOM</b> con nuestro equipo <br>de soporte.</p>
                            <button type="button" (click)="openZoom()" class="btn btn-link text-success fw-bolder ms-auto mt-auto px-0 h5">ACCEDER <i class="fas fa-arrow-right ms-1 fa-lg"></i></button>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="row">
                        <div class="col-6">
                            <div class="card shadow rounded-4 border-success h-100">
                                <img src="assets/images/wa-contact-modal.png" class="rounded-top-4" alt="ALDDA - Zoom">
                                <div class="card-body text-uppercase d-flex flex-column">
                                    <h4 class="card-title text-primary fw-bolder mb-1">Teléfono / <br>Whatsapp</h4>
                                    <p class="card-text text-muted">(554)-440-0300</p>
                                    <a href="https://api.whatsapp.com/send?phone=5544400300" target="_blank" class="btn btn-link text-uppercase text-success fw-bolder ms-auto px-0 h5">
                                        <div class="row d-flex align-items-center">
                                            <div class="col pe-0 text-end">Llamar o <br>enviar mensaje</div>
                                            <div class="col-1 ps-2 pe-4"><i class="fas fa-arrow-right fa-lg"></i></div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="card shadow rounded-4 border-success h-100">
                                <img src="assets/images/email-contact-modal.png" class="rounded-top-4" alt="ALDDA - Zoom">
                                <div class="card-body text-uppercase d-flex flex-column h-100">
                                    <h4 class="card-title text-primary fw-bolder my-1">Correo</h4>
                                    <p class="card-text text-muted">{{'SOPORTE@ALDDA.MX'}}</p>
                                    <a href="mailto:SOPORTE@ALDDA.MX?subject=Necesito ayuda" class="btn btn-link text-uppercase text-success fw-bolder ms-auto mt-auto px-0 h5">Enviar correo <i class="fas fa-arrow-right ms-1 fa-lg"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col">
                            <div class="card shadow rounded-4 border-success">
                                <div class="row g-0">
                                    <div class="col-4 pe-0">
                                        <img src="assets/images/videos-contact-modal.png" class="img-fluid rounded-start-4" alt="...">
                                    </div>
                                    <div class="col-8">
                                        <div class="card-body d-flex flex-column h-100">
                                            <h4 class="card-title text-uppercase text-primary fw-bolder mb-1">Video tutoriales</h4>
                                            <p class="card-text text-muted">Encuentra la solución en los videos <br>tutoriales en nuestro centro de capacitación</p>
                                            <button type="button" (click)="goToHelpCenter()" class="btn btn-link text-success fw-bolder ms-auto mt-auto px-0">ACCEDER A CENTRO DE CAPACITACIÓN <i class="fas fa-arrow-right ms-1 fa-lg"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                        
                </div>
            </div>
        </div>
    </div>
</ng-template>